var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21.4425L16.8375 15.75C18.1912 14.1167 18.8637 12.0246 18.7153 9.90844C18.5669 7.79223 17.609 5.81452 16.0406 4.38609C14.4722 2.95765 12.4138 2.18828 10.293 2.23778C8.17215 2.28728 6.1519 3.15185 4.65185 4.65191C3.15179 6.15196 2.28722 8.17221 2.23772 10.293C2.18822 12.4139 2.95759 14.4722 4.38603 16.0406C5.81446 17.6091 7.79217 18.5669 9.90838 18.7153C12.0246 18.8637 14.1166 18.1912 15.75 16.8375L21.4425 22.5L22.5 21.4425ZM3.74996 10.5C3.74996 9.165 4.14584 7.85995 4.88754 6.74992C5.62924 5.63989 6.68345 4.77473 7.91685 4.26383C9.15025 3.75294 10.5074 3.61927 11.8168 3.87972C13.1262 4.14017 14.3289 4.78305 15.2729 5.72705C16.2169 6.67106 16.8598 7.87379 17.1203 9.18316C17.3807 10.4925 17.247 11.8497 16.7361 13.0831C16.2253 14.3165 15.3601 15.3707 14.2501 16.1124C13.14 16.8541 11.835 17.25 10.5 17.25C8.70975 17.25 6.99286 16.5389 5.72699 15.273C4.46112 14.0071 3.74996 12.2902 3.74996 10.5Z",
    fill: "#CEBF09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e3eedc29f5647a9ada208fdb23633761.svg";
export { ForwardRef as ReactComponent };